import axios from 'axios';
import { useQuery, useMutation } from 'react-query';

import config from '../config';

// apis
const fetchYouTubeChannel = ({ queryKey }) => axios.get(
  `${config?.apiHost}/videos/youtube/channels/${queryKey[1]}`,
  { withCredentials: true }
);

const uploadYouTubeVideo = (data) => axios.put(
  `${config?.apiHost}/videos/youtube`,
  data,
  { withCredentials: true }
);

// queries
export const useYouTubeChannelData = (accessToken) => 
  useQuery(
    ['youtubeChannels', accessToken], fetchYouTubeChannel, {
      enabled: !!accessToken,
    },
  );

// mutations
export const useUploadYouTubeVideoData = () =>
  useMutation(uploadYouTubeVideo);


// WEBPACK FOOTER //
// ./src/hooks/useYouTubeData.js